export const MedicalData = [
    {
      heading: "Medical Academic Journals",
      detail:
        "If you have your medical paper ready for submission in an academic journal, but it's not in the required language, Tomedes can translate your paper, and proofread it too.",
    },
    {
      heading: "Clinical Trials",
      detail:
        "You may be wondering how to translate medical documents, such as those pharmaceutical documents or other types of documents used in clinical trials. We're more than capable of translating these types of documents.",
     
    },
    {
      heading: "Medical Records ",
      detail:
        "Your records, such as medical records, are liable for translation and are handled with security and care at Tomedes.",
        link: "/medical-translation/records"
      
    },
    {
        heading: "Medical Device Manuals",
        detail:
          "For those in the MedTech industry, medical device manuals are transformed by the medical translator into reliable translations.",
      },
      {
        heading: "Telehealth Platforms",
        detail:
          "Translations for telehealth matter just as much as translation in hospitals, which is why at Tomedes we translate everything needed in coordinating virtual visits and remote patient monitoring.",
        
      },
      {
        heading: "Pharmaceutical Documents",
        detail:
          "For pharmacies, medical information such as medicine information leaflets or labels should be understood by the populace. That's what our medical translators do at Tomedes.",
      },
      {
        heading: "Medical Software Guides",
        detail:
          "The software that medical practitioners and healthcare providers use may be in dire need of translation, so send them over to Tomedes medical translation agency. We guarantee safe and secure access.",
        
      },
      {
        heading: "Healthcare Websites",
        detail:
          "Healthcare websites can reach an international audience by becoming multilingual, and the different aspects of the website can be translated by a medical translator.",
      },
      {
        heading: "Case Reports",
        detail:
          "For clinical research, the paper of electronic Case Report Forms (CRFs) may need to be translated into different languages for the sake of those patients participating in clinical trials.",
        
      },
      {
        heading: "Consent Forms",
        detail:
          "For almost all medical procedures, Informed Consent Forms, or ICF, are necessary. So are their translations into languages patients can understand.",
      },
      {
        heading: "Medical Software Localization",
        detail:
          "Need to localize your medical software? At Tomedes, a medical linguist will handle the linguistic, cultural, and translation needs of your localization project.",
      },
      {
        heading: "Promotional Materials for Medical Companies",
        detail:
          "If you're a medical company, all your promotional materials can become translated into significant marketing messages for your audience, at Tomedes.",
      },
      {
        heading: "Manufacturing Procedures",
        detail:
          "If you're a medical manufacturer, your manufacturing manuals, procedures, and leaflets also qualify for translation, so that your materials are in a language that people will understand.",
      },
      {
        heading: "Medical Patents",
        detail:
          "Didn't you think your medical patent qualifies for translation? It does. At Tomedes, we ensure accurate, quality, and convenient translation for your medical patents, too.",
      },
      {
        heading: "Medical Insurance",
        detail:
          "Medical insurance forms, and requirements for medical insurance, such as birth certificates, are also part of the myriad of forms we can translate at Tomedes.",
      },
  ];
  